
const WIDGETS_DEPENDS = {
  'menu': ['blueprint'],
  'breadcrumbs': ['blueprint'],
  'tabs': ['blueprint', 'template-loader'],
  'tabs-switcher': [ 'template-loader'],
  'dropbar': [ 'template-loader'],
  'carousel': [ 'template-loader'],
  'cards': [ 'template-loader'],
  'template': [ 'template-loader'],
  'table': [ 'template-loader', 'blueprint'],
  'input': ['moment'],
  'section': ['section-element-wrapper'],
  'column': ['section-element-wrapper'],
  'section_widget': ['section-element-wrapper'],
  'input-select': ['blueprint', 'blueprint-select'],
  'input-select-tree': ['blueprint', 'blueprint-select'],
  'input-multi-select': ['blueprint', 'blueprint-select'],
  'input-radio': ['blueprint'],
  'input-checkbox': ['blueprint'],
  'input-accept': ['blueprint'],
  'input-file': ['blueprint'],
  'input-gallery': ['blueprint'],
  'input-text': ['blueprint'],
  'input-textarea': ['blueprint'],
  'input-text-common': ['blueprint'],
  'input-text-autocomplete': ['blueprint', 'blueprint-popover'],
  'input-wysiwyg': ['ckeditor'],
  'input-date': ['blueprint', 'blueprint-datetime', 'moment'],
  'input-date-range': ['blueprint', 'blueprint-datetime', 'moment'],
  'input-slider': ['blueprint'],
  'input-range-slider': ['blueprint'],
  'tree': ['blueprint'],
  'scheduler': ['fullcalendar', 'blueprint'],
  'progress-bar': ['blueprint'],
  'input-crop-image': ['image-crop'],
}
export default WIDGETS_DEPENDS;
